<template>
    <v-layout style="min-width: 40px">
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
                <v-btn :disabled="isDisabled" color="accent" fab small @click="openDialog" v-on="on">
                    <v-icon>save_alt</v-icon>
                </v-btn>
            </template>
            <span>{{ $t('Output_CSV_File') }}</span>
        </v-tooltip>
        <the-action-dialog
            :is-show="isShowDialog"
            :btn-word="`${$t('Output')} `"
            :disabled="isDisabled"
            @cancel-dialog="closeDialog"
            @run-action="runAction"
        >
            <template v-slot:dialogHeader>
                <span>
                    {{ $t('Output_CSV_File') }}
                </span>
            </template>
            <template v-slot:dialogMessage>
                <span>
                    {{ $t('Are_you_sure_you_want_to_output_csv_file') }}<br />
                    {{ $t('When_csv_file_output_is_completed,_you_can_download_the_file_from_CSV_File_List.') }}
                </span>
            </template>
        </the-action-dialog>
    </v-layout>
</template>

<script lang="ts">
import { Vue, Component, Watch, Prop, Emit } from 'vue-property-decorator';
import TheActionDialog from '../general/TheActionDialog.vue';

@Component({
    name: 'CsvOutputDialogButton',
    components: {
        TheActionDialog,
    },
})
export default class CsvOutputDialogButton extends Vue {
    @Prop({ default: false }) disabled: boolean;

    isShowDialog = false;

    /**
     * getters
     */
    get isDisabled(): boolean {
        return this.disabled;
    }

    /**
     * methods
     */
    openDialog(): void {
        this.isShowDialog = true;
    }
    closeDialog(): void {
        this.isShowDialog = false;
    }
    runAction(): void {
        this.closeDialog();
        this.outputCsv();
    }
    @Emit()
    public outputCsv() {}
}
</script>
